import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Divider } from '@material-ui/core';
import { useStyles } from '../styles';
import { calculatePlanTotals } from '../utils/calculatePlanTotals';
import QuoteTreatmentPlanButtonsGroup from './QuoteTreatmentPlanButtonsGroup';
import QuoteTreatmentPlanTotals from './QuoteTreatmentPlanTotals';


const defaultTotals = {
  subtotal: 0,
  discountTotal: 0,
  grandTotal: 0,
  quoteDiscount: 0,
  totalSubscription: 0
};

const QuoteTreatmentPlanSummaryBlock = () => {
  const classes = useStyles();
  const [totals, setTotals] = useState(defaultTotals);

  const {
    customerPushCart,
    quotePlan,
    quotePlanSelectedSeriesIds
  } = useSelector((state: IReduxState) => state.quote);

  const products = customerPushCart?.products ?
    Object.values(customerPushCart?.products).map(({product}) => product)
    : [];

  useEffect(() => {
    if (quotePlanSelectedSeriesIds.length) {
      const selectedPlan = quotePlan.filter((plan) => quotePlanSelectedSeriesIds.includes(plan._id));
      const updatedTotals = calculatePlanTotals(products, selectedPlan);
      setTotals(updatedTotals);
    } else {
      setTotals(() => defaultTotals);
    }
  }, [quotePlanSelectedSeriesIds]);

  return (
    <Card className={`${classes.bgBlue} root-card my-4 px-4 pt-4 pb-6`}>
      <QuoteTreatmentPlanButtonsGroup totals={totals} />
      <Divider />
      <QuoteTreatmentPlanTotals totals={totals} />
    </Card>
  );
};

export default QuoteTreatmentPlanSummaryBlock;
